'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _blocks = require('./blocks');

var _blocks2 = _interopRequireDefault(_blocks);

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _elements = require('./elements');

var _elements2 = _interopRequireDefault(_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _extends({
  // allow access to blocks/elements/components via namespaces
  // example:
  // import { blocks } from 'base-components';
  // const Avatar = blocks.Avatar;
  blocks: _blocks2.default,
  components: _components2.default,
  elements: _elements2.default

}, _blocks2.default, _components2.default, _elements2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/index.js
// module id = 5
// module chunks = 2